module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "wrapper-content"
  }, [_c('header', {
    staticClass: "content-header"
  }, [_c('router-link', {
    staticClass: "back-link-spaced",
    attrs: {
      "to": "/contatos/leads"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.back')))]), _c('h1', [_vm._v(_vm._s(_vm.$t('contacts_group.title.index')))])], 1), _c('contacts-picker-text-csv', {
    attrs: {
      "has_groups": _vm.has_groups
    }
  }), _c('router-link', {
    staticClass: "btn btn-gray",
    attrs: {
      "type": "reset",
      "to": "/contatos/leads"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('button', {
    staticClass: "btn btn-primary save",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('contacts.actions.add')))]), (_vm.has_groups) ? _c('confirm-modal', {
    attrs: {
      "id": "confirm-create-groups",
      "title": _vm.$t('general.actions.confirm_actions'),
      "confirm_text": _vm.$t('general.actions.conclude'),
      "confirm_class": "btn-primary"
    },
    on: {
      "confirm-modal-confirm": _vm.confirmGroups
    }
  }, [_c('div', {
    staticClass: "confirm-message"
  }, [_vm._v(_vm._s(_vm.$t('contacts_group.label.importConfirmMessage')) + " ")]), _c('contact-groups-list', {
    attrs: {
      "contact_groups": _vm.contact_groups,
      "view_mode": _vm.contactGroupListViewModes().import,
      "all_initially_selected": true
    },
    on: {
      "group-selected": _vm.handleGroupSelect
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7205a04d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contacts/import/manually.vue
// module id = 1166
// module chunks = 1